"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilityNurseDefaultRatesDto = instanceOfFacilityNurseDefaultRatesDto;
exports.FacilityNurseDefaultRatesDtoFromJSON = FacilityNurseDefaultRatesDtoFromJSON;
exports.FacilityNurseDefaultRatesDtoFromJSONTyped = FacilityNurseDefaultRatesDtoFromJSONTyped;
exports.FacilityNurseDefaultRatesDtoToJSON = FacilityNurseDefaultRatesDtoToJSON;
exports.FacilityNurseDefaultRatesDtoToJSONTyped = FacilityNurseDefaultRatesDtoToJSONTyped;
/**
 * Check if a given object implements the FacilityNurseDefaultRatesDto interface.
 */
function instanceOfFacilityNurseDefaultRatesDto(value) {
    if (!('hourlyRate' in value) || value['hourlyRate'] === undefined)
        return false;
    if (!('onCallRate' in value) || value['onCallRate'] === undefined)
        return false;
    if (!('callbackRate' in value) || value['callbackRate'] === undefined)
        return false;
    if (!('travelStipendEnabled' in value) || value['travelStipendEnabled'] === undefined)
        return false;
    if (!('travelStipendAmount' in value) || value['travelStipendAmount'] === undefined)
        return false;
    if (!('travelStipendMinimumDistance' in value) || value['travelStipendMinimumDistance'] === undefined)
        return false;
    return true;
}
function FacilityNurseDefaultRatesDtoFromJSON(json) {
    return FacilityNurseDefaultRatesDtoFromJSONTyped(json, false);
}
function FacilityNurseDefaultRatesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'hourlyRate': json['hourlyRate'],
        'onCallRate': json['onCallRate'],
        'callbackRate': json['callbackRate'],
        'travelStipendEnabled': json['travelStipendEnabled'],
        'travelStipendAmount': json['travelStipendAmount'],
        'travelStipendMinimumDistance': json['travelStipendMinimumDistance'],
    };
}
function FacilityNurseDefaultRatesDtoToJSON(json) {
    return FacilityNurseDefaultRatesDtoToJSONTyped(json, false);
}
function FacilityNurseDefaultRatesDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'hourlyRate': value['hourlyRate'],
        'onCallRate': value['onCallRate'],
        'callbackRate': value['callbackRate'],
        'travelStipendEnabled': value['travelStipendEnabled'],
        'travelStipendAmount': value['travelStipendAmount'],
        'travelStipendMinimumDistance': value['travelStipendMinimumDistance'],
    };
}
//# sourceMappingURL=FacilityNurseDefaultRatesDto.js.map